module.exports = __webpack_public_path__ + "img/wrapper_m_bg.31b86f6.png";